import { async } from 'rxjs/internal/scheduler/async';
import axios from '../config/axios';

export async function consultarOrden(docId, tipo_esquema) {
  return await axios.get(`formularios_cuestionarios/ordenes/api/v3/leer?docId=${docId}&tipo_esquema=${tipo_esquema}`);
}
export async function crearOrdenDesdeFormulario(creado_por, docId, id, documento) {
  return await axios.post('/controlador_datos/encuentros/api/v1/crear_orden_front', {
    creado_por,
    docId,
    id,
    documento,
  });
}
export async function consultarOrdenesPaciente(documento) {
  return await axios.post('/formularios_cuestionarios/ordenes/api/v3/leer_paciente', {
    documento,
  });
}

export async function actualizarEstadoOrdenes(estado, creado_por, ordenes) {
  return await axios.post('/api/v2/ordenes/gestion/grupal/cambiar_estado', {
    estado,
    creado_por,
    ordenes,
  });
}
export async function ordenesAutomaticas(docId, creado_por, documento) {
  return await axios.post('/agendamiento/api/v1/ordenes/ordenesAutomaticas', {
    docId,
    creado_por,
    documento,
  });
}
export async function actualizarEstadoOrdenesDesdeExcel(file, estado) {
  const formData = new FormData();
  formData.append('fileExcel', file);
  formData.append('estado', estado);
  return await axios({
    method: 'POST',
    url: '/agendamiento/api/v1/ordenes/gestionl',
    data: formData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudOrdenes.js